<template>
<div
  class="loading-data"
  :style="{ width: sizePx, height: sizePx }"
>
  <v-progress-circular
    :size="size"
    :width="thickness"
    color="primary"
    indeterminate
  />
  <div class="loading-text">{{ $t('Loading') }}</div>
</div>
</template>

<script>
export default {
  name: "LoadingData",
  props: {
    size: {
      type: [Number, String],
      default: 80,
      validator: v => [40, 80, 120, 160, 200, 300].includes(Number(v))
    },

  },
  computed: {
    sizePx() {
      return `${this.size}px`;
    },
    thickness() {
      // Thickness is 10% of the spinner size, min 5, max 16
      return Math.max(5, Math.min(16, Math.round(this.size * 0.07)));
    }
  }
};
</script>

<style scoped>
.loading-data {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.loading-text {
  margin-top: 16px;
  font-size: 1.1rem;
  color: #1976d2;
  font-weight: 500;
  text-align: center;
}

.v-progress-circular {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
